import { render, staticRenderFns } from "./SpecialNel.vue?vue&type=template&id=a93b74e0&scoped=true"
import script from "./SpecialNel.vue?vue&type=script&lang=js"
export * from "./SpecialNel.vue?vue&type=script&lang=js"
import style0 from "./SpecialNel.vue?vue&type=style&index=0&id=a93b74e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93b74e0",
  null
  
)

export default component.exports